import * as React from 'react';
import Dialog, { DialogProps } from '@mui/material/Dialog';
import BakeasyCheckbox from '../common/BakeasyCheckbox';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { styled } from '@mui/material/styles';
import { Divider, Grid, IconButton, Typography } from '@mui/material';
import {
  BakeasySelectLabel,
  BakeasySelectLabelLanguage,
} from '../dropdowns/BakeasySelect';
import { Close } from '@mui/icons-material';
import { AppContext } from '../../context/AppContext';
import BakeasyTextField from '../textfields/BakeasyTextField';
import { useEffect, useState } from 'react';
import BakeasyDatePicker from '../common/BakeasyDatePicker';
import { t } from 'i18next';
import {
  STORES,
  PRODUCTS,
  STATUS,
  STATUS_ALL_ARRAY,
  PRODUCT_STATUS_ARRAY,
  MESSAGE_STATUS_ARRAY,
  ORDER_STATUS_ARRAY,
} from '../../constants/Constants';
import { BakeasyButton } from '../buttons/BakeasyButton';
import { BakeasyFilterHeaderLabel } from '../lables/BakeasyHeaderLabel';
import dayjs, { Dayjs } from 'dayjs';
import * as Dropdown from '../dropdowns/BakeasySelect';
import {
  getProfile,
  getProfileState,
} from '../../redux_store/slices/GetUserProfileSlice';
import { useAppDispatch, useAppSelector } from '../../redux_store/reduxStore';
import { formatDateTime } from '../../utils/DateUtils';
import {
  BakeasyAutoCompleteCategory,
  BakeasyAutoCompleteMessagesTo,
  BakeasyAutoCompleteSubCategory,
  BakeasySelectAutoCompleteCities,
  BakeasySelectAutoCompleteMessageFrom,
  BakeasySelectAutoCompleteMessageTo,
  BakeasySelectAutoCompleteStates,
  BakeasySelectAutoCompleteZipcode,
} from '../dropdowns/BakeasyAutoComplete';
import { storesState } from '../../redux_store/slices/storesSlice';
import { storeProductState } from '../../redux_store/slices/storeProductSlice';
import {
  allstoresState,
  fetchAllStores,
} from '../../redux_store/slices/messageStoreSlice';
import * as TextField from '../textfields/BakeasyTextFields';
import { productsState } from '../../redux_store/slices/productsSlice';
import { useSelector } from 'react-redux';
import {
  fetchNewMessageCount,
  getNamesList,
  messagesState,
} from '../../redux_store/slices/messagesSlice';
import { validateField } from '../../utils/ValidationUtils';
import {
  dropdownDataState,
  fetchDropdownData,
} from '../../redux_store/slices/dropdownDataSlice';
import { fetchNewOrderCount } from '../../redux_store/slices/ordersSlice';
import { GRAY_500 } from '../../constants/Colors';

export interface BakeasyConfirmDialogProps {
  dialog?: BakeasyConfirmDialogProp;
}

export interface BakeasyConfirmDialogProp {
  type?: string;
  open?: boolean;
  title?: any;
  message?: string | any;
  data?: any;
  onNoClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onYesClick?: (
    event: React.MouseEvent<HTMLButtonElement>,
    param?: any
  ) => void;
}

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': { padding: theme.spacing(2) },
  '& .MuiDialogActions-root': { padding: theme.spacing(1) },
}));

export default function BakeasyConfirmDialog(props: BakeasyConfirmDialogProps) {
  const dispatch = useAppDispatch();
  let myContext = React.useContext(AppContext);

  const [text, setText] = useState<string>('');
  const [error, setError] = useState<string>('');
  const [selectStores, setSelectStores] = useState<any>('');
  const [selectProduct, setSelectProduct] = useState<any>('');
  const [toAllStores, setToAllStores] = useState<any>(false);
  const [selectContent, setSelectContent] = useState<any>('');
  const [selectProducts, setSelectProducts] = useState<any>('');
  const [selectStatus, setSelectStatus] = useState<any>('');
  const [selectedCategory, setSelectedCategory] = useState<any>('');
  const [selectedSubCategory, setSelectedSubCategory] = useState<any>('');
  const [selectedStatus, setSelectedStatus] = useState<any>('');
  const [selectedAssignment, setSelectedAssignment] = useState<any>('');
  const [selectedRecipeBuilder, setSelectedRecipeBuilder] = useState<any>('');
  const [selectedLanguage, setSelectedLanguage] = React.useState('');
  const [selectedPriority, setSelectedPriority] = useState<any>('');
  const [checkedPriority, setCheckedPriority] = useState<any>('normal');
  const [selectedMessageStatus, setSelectedMessageStatus] = useState<any>('');
  const [createdFromDate, setCreatedFromDate] = useState<Dayjs | null>(null);
  const [createdToDate, setCreatedToDate] = useState<Dayjs | null>(null);
  const [selectedMessageFrom, setSelectedMessageFrom] = useState<any>();
  const [selectedMessageTo, setSelectedMessageTo] = useState<any>();
  const [lastAccessToDate, setLastAccessToDate] = useState<Dayjs | null>(null);
  const [lastOrderFromDate, setLastOrderFromDate] = useState<Dayjs | null>(
    null
  );
  const [lastOrderToDate, setLastOrderToDate] = useState<Dayjs | null>(null);
  const [selectedName, setSelectName] = useState<any>(undefined);
  const [selectSubject, setSelectSubject] = useState<any>('');

  const [selectedState, setSelectedState] = useState<any>('');
  const [selectedCity, setSelectedCity] = useState<any>('');
  const [zipCode, setZipCode] = useState<any>('');
  const [lastAccessFromDate, setLastAccessFromDate] = useState<Dayjs | null>(
    null
  );
  const [orderedFromDate, setOrderedFromDate] = useState<Dayjs | null>(null);
  const [orderedToDate, setOrderedToDate] = useState<Dayjs | null>(null);
  const [dueFromDate, setDueFromDate] = useState<Dayjs | null>(null);
  const [dueToDate, setDueToDate] = useState<Dayjs | null>(null);
  const [invoiceFromDate, setInvoiceFromDate] = useState<Dayjs | null>(null);
  const [invoiceToDate, setInvoiceToDate] = useState<Dayjs | null>(null);

  const [isView, setIsView] = useState<boolean>(false);
  const [maxWidth, setMaxWidth] = React.useState<DialogProps['maxWidth']>('sm');
  const [selectedProductType, setSelectedProductType] = useState<any>('');

  let _storesState: any = useAppSelector(allstoresState);
  let _userProfile: any = useAppSelector(getProfileState);
  let _storeState = useAppSelector(storesState);
  let _productsState = useAppSelector(productsState);
  let _storeProductsState = useAppSelector(storeProductState);
  let _messagesState = useAppSelector(messagesState);
  let _dropdownDataState = useAppSelector(dropdownDataState);

  const auth = useSelector((x: any) => x?.auth?.value);

  React.useEffect(() => {
    setSelectedLanguage(_userProfile?.value?.defaultLanguage);
  }, [_userProfile.value]);

  useEffect(() => {
    if (auth === undefined) {
      return;
    }

    if (_userProfile?.value === undefined) {
      dispatch(getProfile(''));
      dispatch(fetchNewMessageCount(''));
      dispatch(fetchNewOrderCount(''));
    } else {
      setSelectedLanguage(_userProfile?.value?.defaultLanguage);
    }
    if (_dropdownDataState?.value?.data?.PaymentMethod.length === 0) {
      dispatch(fetchDropdownData());
    }
    if (_storesState?.name.length === 0) {
      dispatch(fetchAllStores({ page: 1, limit: 10 }));
    }
  }, []);

  useEffect(() => {
    props?.dialog?.data?.createdFromDate &&
      setCreatedFromDate(dayjs(props?.dialog?.data?.createdFromDate));
    props?.dialog?.data?.createdToDate &&
      setCreatedToDate(dayjs(props?.dialog?.data?.createdToDate));
    props?.dialog?.data?.lastAccessFromDate &&
      setLastAccessFromDate(dayjs(props?.dialog?.data?.lastAccessFromDate));
    props?.dialog?.data?.lastAccessToDate &&
      setLastAccessToDate(dayjs(props?.dialog?.data?.lastAccessToDate));
    props?.dialog?.data?.lastOrderFromDate &&
      setLastOrderFromDate(dayjs(props?.dialog?.data?.lastOrderFromDate));
    props?.dialog?.data?.lastOrderToDate &&
      setLastOrderToDate(dayjs(props?.dialog?.data?.lastOrderToDate));
    props?.dialog?.data?.orderedFromDate &&
      setOrderedFromDate(dayjs(props?.dialog?.data?.orderedFromDate));
    props?.dialog?.data?.orderedToDate &&
      setOrderedToDate(dayjs(props?.dialog?.data?.orderedToDate));
    props?.dialog?.data?.dueFromDate &&
      setDueFromDate(dayjs(props?.dialog?.data?.dueFromDate));
    props?.dialog?.data?.dueToDate &&
      setDueToDate(dayjs(props?.dialog?.data?.dueToDate));

    props?.dialog?.data?.state && setSelectedState(props?.dialog?.data?.state);
    props?.dialog?.data?.city && setSelectedCity(props?.dialog?.data?.city);
    props?.dialog?.data?.zipCode && setZipCode(props?.dialog?.data?.zipCode);
    props?.dialog?.data?.status &&
      setSelectedStatus(props?.dialog?.data?.status);
    props?.dialog?.data?.categoryName &&
      setSelectedCategory(props?.dialog?.data?.categoryName);
    props?.dialog?.data?.subCategoryName &&
      setSelectedSubCategory(props?.dialog?.data?.subCategoryName);
    props?.dialog?.data?.productType &&
      setSelectedProductType(props?.dialog?.data?.productType);
    props?.dialog?.data?.productAssignment &&
      setSelectedAssignment(props?.dialog?.data?.productAssignment);
    props?.dialog?.data?.receipeBuilder &&
      setSelectedRecipeBuilder(
        props?.dialog?.data?.receipeBuilder === true ? 'Yes' : 'No'
      );
    props?.dialog?.data?.priority &&
      setSelectedPriority(props?.dialog?.data?.priority);
    props?.dialog?.data?.to && setSelectedMessageTo(props?.dialog?.data?.to);
    props?.dialog?.data?.from &&
      setSelectedMessageFrom(props?.dialog?.data?.from);
    props?.dialog?.data?.status &&
      setSelectedMessageStatus(props?.dialog?.data?.status);
    props?.dialog?.data?.invoiceFromDate &&
      setInvoiceFromDate(dayjs(props?.dialog?.data?.invoiceFromDate));
    props?.dialog?.data?.invoiceToDate &&
      setInvoiceToDate(dayjs(props?.dialog?.data?.invoiceToDate));
  }, [props?.dialog?.data]);

  function handleOnClose() {
    setError('');
    setText('');
    setCreatedFromDate(null);
    setCreatedToDate(null);
    setLastAccessFromDate(null);
    setLastAccessToDate(null);
    setLastOrderFromDate(null);
    setLastOrderToDate(null);
    setOrderedFromDate(null);
    setOrderedToDate(null);
    setDueFromDate(null);
    setDueToDate(null);
    setSelectedState('');
    setSelectedCity('');
    setZipCode('');
    setSelectedStatus('');
    setSelectedCategory('');
    setSelectedSubCategory('');
    setSelectedProductType('');
    setSelectedRecipeBuilder('');

    setSelectedPriority('');
    setSelectStatus('');
    setSelectedMessageStatus('');
    setSelectedMessageFrom('');
    setSelectedMessageTo('');

    setSelectName('');
    setSelectSubject('');
    setSelectContent('');
    setCheckedPriority('normal');

    setSelectStores('');
    setInvoiceToDate(null);
    setInvoiceFromDate(null);
    myContext.setConfirmDialog({ open: false });
  }

  function handleActivation(event: any, activation: boolean) {
    if (activation) {
      if (props?.dialog?.onYesClick) {
        props?.dialog?.onYesClick(event, activation);
        handleOnClose();
      }
    }
  }

  function handleOnYes(event: any) {
    switch (props.dialog?.type) {
      case 'deActivate':
        if (text === 'DEACTIVATE') {
          handleActivation(event, true);
        } else {
          setError(t('PLEASE_TYPE_DEACTIVATE'));
        }
        break;
      case 'reActivate':
        if (text === 'REACTIVATE') {
          handleActivation(event, true);
        } else {
          setError(t('PLEASE_TYPE_REACTIVATE'));
        }
        break;
      case 'assign':
        if (text === 'ASSIGN') {
          handleActivation(event, true);
        } else {
          setError(t('PLEASE_TYPE_ASSIGN'));
        }
        break;
      case 'unassign':
        if (text === 'UNASSIGN') {
          handleActivation(event, true);
        } else {
          setError(t('PLEASE_TYPE_UNASSIGN'));
        }
        break;
      case 'language-Dialog':
        if (props?.dialog?.onYesClick) {
          props?.dialog?.onYesClick(event, selectedLanguage);
          handleOnClose();
        }
        break;
      case 'productActivation':
        if (props?.dialog?.onYesClick) {
          props?.dialog?.onYesClick(event, selectedStatus);
          handleOnClose();
        }
        break;
      case 'store-filter':
        handleStoreFilterApply(event);
        break;
      case 'store-product-filter':
        handleStoreProductFilterApply(event);
        break;
      case 'product-filter':
        handleProductFilterApply(event);
        break;
      case 'message-filter':
        handleMessageFilterApply(event);
        break;
      case 'order-filter':
        handleOrderFilterApply(event);
        break;
      case 'activeOrder-filter':
        handleActiveOrderFilterApply(event);
        break;
      case 'message-compose':
        if (
          !toAllStores &&
          !validateField(dispatch, 'PLEASE_SELECT_NAME', selectedName)
        ) {
          return false;
        }
        if (!validateField(dispatch, 'PLEASE_ENTER_SUBJECT', selectSubject)) {
          return false;
        }
        if (
          !validateField(dispatch, 'PLEASE_ENTER_DESCRIPTION', selectContent)
        ) {
          return false;
        }
        if (props?.dialog?.onYesClick) {
          props?.dialog?.onYesClick(event, {
            selectedName,
            selectSubject,
            selectContent,
            checkedPriority,
            toAllStores,
          });
          handleOnClose();
        }
        break;
      case 'invoice/shipping-filter':
        handleShippingFilterApply(event);
        break;
      case 'invoice-filter':
        handleInvoiceFilterApply(event);
        break;
      default:
        if (props?.dialog?.onYesClick) {
          props?.dialog?.onYesClick(event);
          handleOnClose();
        }
    }
  }

  function handleStoreFilterApply(event: any) {
    let filter = {
      ...(createdFromDate && {
        createdFromDate: formatDateTime(createdFromDate?.toISOString()),
      }),
      ...(createdToDate && {
        createdToDate: formatDateTime(createdToDate?.toISOString()),
      }),
      ...(lastAccessFromDate && {
        lastAccessFromDate: formatDateTime(lastAccessFromDate?.toISOString()),
      }),
      ...(lastAccessToDate && {
        lastAccessToDate: formatDateTime(lastAccessToDate?.toISOString()),
      }),
      ...(lastOrderFromDate && {
        lastOrderFromDate: formatDateTime(lastOrderFromDate?.toISOString()),
      }),
      ...(lastOrderToDate && {
        lastOrderToDate: formatDateTime(lastOrderToDate?.toISOString()),
      }),
      ...(selectedState && { state: selectedState }),
      ...(selectedCity && { city: selectedCity }),
      ...(zipCode && { zipCode: zipCode }),
      ...(selectProducts && { products: selectProducts }),
      ...(selectedStatus && { status: selectedStatus }),
    };

    if (props?.dialog?.onYesClick) {
      props?.dialog?.onYesClick(event, filter);
      handleOnClose();
    }
  }

  function handleProductFilterApply(event: any) {
    let filter = {
      ...(selectedCategory && { categoryName: selectedCategory }),
      ...(selectedSubCategory && { subCategoryName: selectedSubCategory }),
      ...(selectedStatus && {
        status:
          selectedStatus === 'Temp. Unavailable'
            ? 'Unavailable'
            : selectedStatus,
      }),
      ...(selectedProductType && { productType: selectedProductType }),
      ...(selectedRecipeBuilder && {
        receipeBuilder: selectedRecipeBuilder === 'Yes' ? true : false,
      }),
    };

    if (props?.dialog?.onYesClick) {
      props?.dialog?.onYesClick(event, filter);
      handleOnClose();
    }
  }

  function handleStoreProductFilterApply(event: any) {
    let filter = {
      ...(selectedCategory && { categoryName: selectedCategory }),
      ...(selectedSubCategory && { subCategoryName: selectedSubCategory }),
      ...(selectedAssignment && { productStatus: selectedAssignment }),
      ...(selectedStatus && {
        status:
          selectedStatus === 'Temp. Unavailable'
            ? 'Unavailable'
            : selectedStatus,
      }),
    };

    if (props?.dialog?.onYesClick) {
      props?.dialog?.onYesClick(event, filter);
      handleOnClose();
    }
  }
  function handleMessageFilterApply(event: any) {
    let filter = {
      ...(createdFromDate && {
        createdFromDate: formatDateTime(createdFromDate?.toISOString()),
      }),
      ...(createdToDate && {
        createdToDate: formatDateTime(createdToDate?.toISOString()),
      }),
      ...(selectedPriority && { priority: selectedPriority }),
      ...(selectedMessageFrom && { from: selectedMessageFrom }),
      ...(selectedMessageTo && { to: selectedMessageTo }),
      ...(selectedMessageStatus && { status: selectedMessageStatus }),
    };

    if (props?.dialog?.onYesClick) {
      props?.dialog?.onYesClick(event, filter);
      handleOnClose();
    }
  }
  function handleOrderFilterApply(event: any) {
    let filter = {
      ...(orderedFromDate && {
        orderedFromDate: formatDateTime(orderedFromDate?.toISOString()),
      }),
      ...(orderedToDate && {
        orderedToDate: formatDateTime(orderedToDate?.toISOString()),
      }),
      ...(dueFromDate && {
        dueFromDate: formatDateTime(dueFromDate?.toISOString()),
      }),
      ...(dueToDate && { dueToDate: formatDateTime(dueToDate?.toISOString()) }),
      ...(selectedStatus && { status: selectedStatus }),
    };

    if (props?.dialog?.onYesClick) {
      props?.dialog?.onYesClick(event, filter);
      handleOnClose();
    }
  }
  function handleActiveOrderFilterApply(event: any) {
    let filter = {
      ...(orderedFromDate && {
        orderedFromDate: formatDateTime(orderedFromDate?.toISOString()),
      }),
      ...(orderedToDate && {
        orderedToDate: formatDateTime(orderedToDate?.toISOString()),
      }),
      ...(dueFromDate && {
        dueFromDate: formatDateTime(dueFromDate?.toISOString()),
      }),
      ...(dueToDate && { dueToDate: formatDateTime(dueToDate?.toISOString()) }),
      ...(selectedStatus && { status: selectedStatus }),
    };

    if (props?.dialog?.onYesClick) {
      props?.dialog?.onYesClick(event, filter);
      handleOnClose();
    }
  }

  function handleShippingFilterApply(event: any) {
    let filter = {
      ...(dueToDate && { dueToDate: formatDateTime(dueToDate?.toISOString()) }),
      ...(dueFromDate && {
        dueFromDate: formatDateTime(dueFromDate?.toISOString()),
      }),
    };
    if (props?.dialog?.onYesClick) {
      props?.dialog?.onYesClick(event, filter);
      handleOnClose();
    }
  }

  function handleInvoiceFilterApply(event: any) {
    let filter = {
      ...(invoiceFromDate && {
        invoiceFromDate: formatDateTime(invoiceFromDate?.toISOString()),
      }),
      ...(invoiceToDate && {
        invoiceToDate: formatDateTime(invoiceToDate?.toISOString()),
      }),
    };

    if (props?.dialog?.onYesClick) {
      props?.dialog?.onYesClick(event, filter);
      handleOnClose();
    }
  }

  function messageCompose() {
    if (_storesState?.name.length === 0) {
      dispatch(fetchAllStores({ page: 1, limit: 10 }));
    }

    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <BakeasyAutoCompleteMessagesTo
            multiple={true}
            disabled={toAllStores}
            //value={selectedName}
            options={_storesState?.name}
            onChange={(newValue: any) => {
              if (typeof newValue === 'string' && newValue?.length > 2) {
                dispatch(
                  fetchAllStores({ page: 1, limit: 10, search: newValue })
                );
              }
              if (typeof newValue === 'string' && newValue?.length === 0) {
                dispatch(
                  fetchAllStores({ page: 1, limit: 10, search: newValue })
                );
              }
              if (typeof newValue === 'object') {
                setSelectName(newValue);
              }
            }}
          />
          <BakeasyCheckbox
            label={t('TO_ALL_STORES')}
            value={toAllStores}
            onClick={(event: any) => {
              setToAllStores(event?.target?.checked);
              // if (event?.target?.checked) {
              //   setSelectName(undefined);
              // }
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField.Subject
            value={selectSubject}
            required={true}
            onChange={(event: any) => {
              setSelectSubject(event.target.value);
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField.Description
            value={selectContent}
            required={true}
            placeHolder={t('ENTER_DESCRIPTION')}
            maxLength={500}
            onChange={(event: any) => {
              setSelectContent(event.target.value);
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <small style={{ color: GRAY_500 }}>
            {t('NOTE_YOU_CAN_ENTER_UP_TO_500_CHARACTERS')}
          </small>
        </Grid>
        <Grid item xs={12}>
          <BakeasyCheckbox
            label={t('SET_AS_HIGH_PRIORITY')}
            value={checkedPriority === 'urgent'}
            onClick={(event: any) => {
              if (event?.target?.checked) {
                setCheckedPriority('urgent');
              } else {
                setCheckedPriority('normal');
              }
            }}
          />
        </Grid>
      </Grid>
    );
  }

  function getLabelForNoButton(type: string | undefined): any {
    switch (type) {
      case 'deActivate':
      case 'reActivate':
      case 'message-filter':
      case 'message-compose':
      case 'language-Dialog':
      case 'filter':
      case 'store-filter':
      case 'store-product-filter':
      case 'invoice/shipping-filter':
      case 'invoice-filter':
      case 'product-filter':
      case 'order-filter':
      case 'activeOrder-filter':
        return 'CANCEL';
      case 'contact':
      case 'confirm-validation-message':
        return 'BACK';
      case 'productActivation':
        return 'CLOSE';
      default:
        return 'No';
    }
  }

  function getLabelForYesButton(type: string | undefined): any {
    switch (type) {
      case 'deActivate':
        return 'DEACTIVATE';
      case 'reActivate':
        return 'REACTIVATE';
      case 'filter':
      case 'store-filter':
      case 'store-product-filter':
      case 'message-filter':
      case 'invoice/shipping-filter':
      case 'invoice-filter':
      case 'product-filter':
      case 'order-filter':
      case 'activeOrder-filter':
        return 'APPLY';
      case 'message-compose':
        return 'SEND';
      case 'language-Dialog':
        return 'SAVE';
      case 'forgotPassword':
        return 'OK';
      case 'assign':
        return 'ASSIGN';
      case 'unassign':
        return 'UNASSIGN';
      case 'productActivation':
        return 'UPDATE';
      case 'confirm-validation-message':
        return 'CONTINUE';
      default:
        return 'Yes';
    }
  }

  function commonFilter() {
    return (
      <>
        <Grid item display={'flex'} columnGap={2}>
          <BakeasyFilterHeaderLabel message={t('CREATED_DATE')} />
        </Grid>
        <Grid item display={'flex'} columnGap={2}>
          <BakeasyDatePicker
            label={t('FROM')}
            value={createdFromDate}
            onChange={(value: any) => {
              setCreatedFromDate(value);
            }}
          />
          <BakeasyDatePicker
            label={t('TO')}
            value={createdToDate}
            onChange={(value: any) => {
              setCreatedToDate(value);
            }}
          />
        </Grid>
      </>
    );
  }

  function storeFilter() {
    return (
      <>
        <Grid item display={'flex'} columnGap={2} sx={{ marginTop: 1 }}>
          <BakeasyFilterHeaderLabel message={t('LAST_ORDER_DATE')} />
        </Grid>
        <Grid item display={'flex'} columnGap={2}>
          <BakeasyDatePicker
            label={t('FROM')}
            value={lastOrderFromDate}
            onChange={(value: any) => {
              setLastOrderFromDate(value);
            }}
          />
          <BakeasyDatePicker
            label={t('TO')}
            value={lastOrderToDate}
            onChange={(value: any) => {
              setLastOrderToDate(value);
            }}
          />
        </Grid>

        <Grid container spacing={2} mt={1}>
          <Grid item xs={12} sm={6} md={6} lg={6} xl={4}>
            <BakeasySelectAutoCompleteStates
              value={selectedState}
              options={_storeState?.value?.states}
              onChange={(newValue: any) => {
                if (typeof newValue === 'string' && newValue?.length > 0) {
                  if (_storeState?.value?.states?.includes(newValue)) {
                    setSelectedState(newValue);
                  }
                }
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6} xl={4}>
            <BakeasySelectAutoCompleteCities
              value={selectedCity}
              options={_storeState.value?.cities}
              onChange={(newValue: any) => {
                if (typeof newValue === 'string' && newValue?.length > 1) {
                  if (_storeState?.value?.cities?.includes(newValue)) {
                    setSelectedCity(newValue);
                  }
                }
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6} xl={4}>
            <BakeasySelectAutoCompleteZipcode
              value={zipCode}
              options={_storeState?.value?.zipCodes}
              onChange={(newValue: any) => {
                if (_storeState?.value?.zipCodes?.includes(newValue)) {
                  setZipCode(newValue);
                }
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={6} xl={4}>
            <Dropdown.Status
              options={STATUS_ALL_ARRAY}
              value={selectedStatus}
              onChange={(event: any) => setSelectedStatus(event?.target?.value)}
            />
          </Grid>
        </Grid>
      </>
    );
  }

  function productFilter() {
    return (
      <>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={6} lg={6} xl={4}>
            <BakeasyAutoCompleteCategory
              value={selectedCategory}
              options={_productsState?.value?.categories}
              onChange={(newValue: any) => {
                if (typeof newValue === 'string' && newValue?.length > 0) {
                  if (_productsState?.value?.categories?.includes(newValue)) {
                    setSelectedCategory(newValue);
                  }
                }
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6} xl={4}>
            <BakeasyAutoCompleteSubCategory
              value={selectedSubCategory}
              options={_productsState?.value?.subCategories}
              onChange={(newValue: any) => {
                if (typeof newValue === 'string' && newValue?.length > 0) {
                  if (
                    _productsState?.value?.subCategories?.includes(newValue)
                  ) {
                    setSelectedSubCategory(newValue);
                  }
                }
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6} xl={4}>
            <Dropdown.Status
              value={selectedStatus}
              options={PRODUCT_STATUS_ARRAY}
              onChange={(event: any) => setSelectedStatus(event?.target?.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6} xl={4}>
            <Dropdown.SelectProductType
              value={selectedProductType}
              onChange={(event: any) => {
                setSelectedProductType(event.target.value);
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6} xl={4}>
            <Dropdown.SelectRecipeBuilder
              value={selectedRecipeBuilder}
              onChange={(event: any) => {
                setSelectedRecipeBuilder(event.target.value);
              }}
            />
          </Grid>
        </Grid>
      </>
    );
  }

  function messageFilter() {
    return (
      <>
        <Grid container spacing={2}>
          <Grid item>
            <BakeasyFilterHeaderLabel message={t('CREATED_DATE')} />
          </Grid>
          <Grid item container spacing={2}>
            <Grid item xs={12} sm={6} md={6} lg={6} xl={4}>
              <BakeasyDatePicker
                label={t('FROM')}
                value={createdFromDate}
                onChange={(value: any) => {
                  setCreatedFromDate(value);
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6} xl={4}>
              <BakeasyDatePicker
                label={t('TO')}
                value={createdToDate}
                onChange={(value: any) => {
                  setCreatedToDate(value);
                }}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={6} lg={6} xl={4}>
              <Dropdown.Priority
                value={selectedPriority}
                onChange={(event) => setSelectedPriority(event?.target?.value)}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={6} lg={6} xl={4}>
              <Dropdown.MessageStatus
                options={MESSAGE_STATUS_ARRAY}
                value={selectedMessageStatus}
                onChange={(event) =>
                  setSelectedMessageStatus(event?.target?.value)
                }
              />
            </Grid>

            <Grid item xs={12} sm={6} md={6} lg={6} xl={4}>
              <BakeasySelectAutoCompleteMessageFrom
                disabled={isView}
                value={selectedMessageFrom}
                options={_messagesState?.name}
                onChange={(newValue: any) => {
                  if (newValue === null) {
                    setSelectedMessageFrom(undefined);
                    dispatch(getNamesList({ page: 1, limit: 5 }));
                  }

                  if (typeof newValue === 'string' && newValue?.length > 2) {
                    if (
                      _messagesState?.name?.find(
                        (item: any) => item?.name === newValue
                      )
                    ) {
                      setSelectedMessageFrom(newValue);
                    } else {
                      dispatch(
                        getNamesList({ page: 1, limit: 5, search: newValue })
                      );
                    }
                  }
                  if (typeof newValue === 'string' && newValue?.length === 0) {
                    dispatch(getNamesList({ page: 1, limit: 5 }));
                  }
                }}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={6} lg={6} xl={4}>
              <BakeasySelectAutoCompleteMessageTo
                disabled={isView}
                value={selectedMessageTo}
                options={_messagesState?.name}
                onChange={(newValue: any) => {
                  if (newValue === null) {
                    setSelectedMessageTo(undefined);
                    dispatch(getNamesList({ page: 1, limit: 5 }));
                  }
                  if (typeof newValue === 'string' && newValue?.length > 2) {
                    if (
                      _messagesState?.name?.find(
                        (item: any) => item?.name === newValue
                      )
                    ) {
                      setSelectedMessageTo(newValue);
                    } else {
                      dispatch(
                        getNamesList({ page: 1, limit: 5, search: newValue })
                      );
                    }

                    if (
                      typeof newValue === 'string' &&
                      newValue?.length === 0
                    ) {
                      dispatch(getNamesList({ page: 1, limit: 5 }));
                    }
                  }
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      </>
    );
  }

  function commonshippingInvoiceFilter() {
    return (
      <>
        <Grid item display={'flex'} columnGap={2}>
          <BakeasyFilterHeaderLabel message={t('DUE_DATE')} />
        </Grid>
        <Grid item display={'flex'} columnGap={2}>
          <BakeasyDatePicker
            label={t('FROM')}
            value={dueFromDate}
            onChange={(value: any) => {
              setDueFromDate(value);
            }}
          />
          <BakeasyDatePicker
            label={t('TO')}
            value={dueToDate}
            onChange={(value: any) => {
              setDueToDate(value);
            }}
          />
        </Grid>
      </>
    );
  }

  function orderFilter() {
    return (
      <>
        <Grid item display={'flex'} columnGap={2} sx={{ marginTop: 0 }}>
          <BakeasyFilterHeaderLabel message={t('ORDER_DATE')} />
        </Grid>
        <Grid item display={'flex'} columnGap={2}>
          <BakeasyDatePicker
            label={t('FROM')}
            value={orderedFromDate}
            onChange={(value: any) => {
              setOrderedFromDate(value);
            }}
          />
          <BakeasyDatePicker
            label={t('TO')}
            value={orderedToDate}
            onChange={(value: any) => {
              setOrderedToDate(value);
            }}
          />
        </Grid>

        <Grid item display={'flex'} columnGap={2} sx={{ marginTop: 1 }}>
          <BakeasyFilterHeaderLabel message={t('DUE_DATE')} />
        </Grid>
        <Grid item display={'flex'} columnGap={2}>
          <BakeasyDatePicker
            label={t('FROM')}
            value={dueFromDate}
            onChange={(value: any) => {
              setDueFromDate(value);
            }}
          />
          <BakeasyDatePicker
            label={t('TO')}
            value={dueToDate}
            onChange={(value: any) => {
              setDueToDate(value);
            }}
          />
        </Grid>

        <Grid container spacing={2} mt={0}>
          <Grid item xs={12} sm={6}>
            <Dropdown.Status
              value={selectedStatus}
              options={ORDER_STATUS_ARRAY}
              onChange={(event: any) => setSelectedStatus(event?.target?.value)}
            />
          </Grid>
          {/* <Grid item xs={12} sm={6}>
              <BakeasyDatePicker
                label={t('TO')}
                value={invoicedToDate}
                onChange={(value: any) => {
                  setInvoicedToDate(value);
                }}
              />
            </Grid> */}
        </Grid>
      </>
    );
  }

  function invoiceFilter() {
    return (
      <>
        <Grid item display={'flex'} columnGap={2}>
          <BakeasyFilterHeaderLabel message={t('INVOICE_DATE')} />
        </Grid>
        <Grid item display={'flex'} columnGap={2}>
          <BakeasyDatePicker
            label={t('FROM')}
            value={invoiceFromDate}
            onChange={(value: any) => {
              setInvoiceFromDate(value);
            }}
          />
          <BakeasyDatePicker
            label={t('TO')}
            value={invoiceToDate}
            onChange={(value: any) => {
              setInvoiceToDate(value);
            }}
          />
        </Grid>
      </>
    );
  }

  function Cancel() {
    return (
      <>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          xl={12}
          sx={{ marginTop: 1 }}
        >
          <Typography variant="h1">
            Are you sure you want to cancel ?
          </Typography>
        </Grid>
      </>
    );
  }

  function storeProductFilter() {
    return (
      <>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
            <BakeasyAutoCompleteCategory
              value={selectedCategory}
              options={_storeProductsState?.value?.categories}
              onChange={(newValue: any) => {
                if (typeof newValue === 'string' && newValue?.length > 0) {
                  if (
                    _storeProductsState?.value?.categories?.includes(newValue)
                  ) {
                    setSelectedCategory(newValue);
                  }
                }
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
            <BakeasyAutoCompleteSubCategory
              value={selectedSubCategory}
              options={_storeProductsState?.value?.subCategories}
              onChange={(newValue: any) => {
                if (typeof newValue === 'string' && newValue?.length > 0) {
                  if (
                    _storeProductsState?.value?.subCategories?.includes(
                      newValue
                    )
                  ) {
                    setSelectedSubCategory(newValue);
                  }
                }
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
            <Dropdown.Status
              value={selectedStatus}
              onChange={(event: any) => setSelectedStatus(event?.target?.value)}
            />
          </Grid>
        </Grid>

        <Grid container spacing={2} mt={1}>
          <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
            <Dropdown.Assignment
              value={selectedAssignment}
              onChange={(event: any) =>
                setSelectedAssignment(event?.target?.value)
              }
            />
          </Grid>
        </Grid>
      </>
    );
  }

  function activeOrderFilter() {
    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <BakeasyFilterHeaderLabel message={t('ORDER_DATE')} />
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <BakeasyDatePicker
                label={t('FROM')}
                value={orderedFromDate}
                onChange={(value: any) => {
                  setOrderedFromDate(value);
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <BakeasyDatePicker
                label={t('TO')}
                value={orderedToDate}
                onChange={(value: any) => {
                  setOrderedToDate(value);
                }}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <BakeasyFilterHeaderLabel message={t('DUE_DATE')} />
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <BakeasyDatePicker
                label={t('FROM')}
                value={dueFromDate}
                onChange={(value: any) => {
                  setDueFromDate(value);
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <BakeasyDatePicker
                label={t('TO')}
                value={dueToDate}
                onChange={(value: any) => {
                  setDueToDate(value);
                }}
              />
            </Grid>
          </Grid>

          <Grid container spacing={2} mt={0}>
            <Grid item xs={12} sm={6}>
              <Dropdown.Status
                value={selectedStatus}
                options={ORDER_STATUS_ARRAY}
                onChange={(event: any) =>
                  setSelectedStatus(event?.target?.value)
                }
              />
            </Grid>
            {/* <Grid item xs={12} sm={6}>
              <BakeasyDatePicker
                label={t('TO')}
                value={invoicedToDate}
                onChange={(value: any) => {
                  setInvoicedToDate(value);
                }}
              />
            </Grid> */}
          </Grid>
          {/* <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={6} lg={6} xl={4}>
              <Dropdown.Status
                options={STATUS_ALL_ARRAY}
                value={selectedStatus}
                onChange={(event: any) => setSelectedStatus(event?.target?.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6} xl={4}>
              <BakeasySelectLabel
                required={true}
                label={t('STORES')}
                size="small"
                statusOptions={STORES}
                fullWidth={true}
                value={selectStores}
                onChange={event => setSelectStores(event?.target?.value)}
              />
            </Grid>
          </Grid> */}
        </Grid>
      </Grid>
    );
  }

  function getContent(type: string | undefined, data: any): any {
    switch (type) {
      case 'contact':
        return (
          <Grid container>
            <Grid item xs={12} sm={6} md={6}>
              <Typography m={2}>
                <b>{t('FIRST_NAME')}</b>: {data?.firstName}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <Typography m={2}>
                <b>{t('LAST_NAME')}</b>: {data?.lastName}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <Typography m={2}>
                <b>{t('EMAIL_ID')}</b>: {data?.email}
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6} md={6}>
              <Typography m={2}>
                <b>{t('MOBILE')}</b>: {data?.mobile}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <Typography m={2}>
                <b>{t('WORK')}</b>: {data?.work}
              </Typography>
            </Grid>
          </Grid>
        );

      case 'filter':
        return (
          <Grid>
            <Grid item display={'flex'} columnGap={2}>
              <Typography variant="h1" sx={{ fontWeight: 'bold' }}>
                Created Date
              </Typography>
            </Grid>
            <Grid item display={'flex'} columnGap={2}>
              <BakeasyDatePicker label={'From:'} />
              <BakeasyDatePicker label={'To:'} />
            </Grid>
            <Grid item display={'flex'} columnGap={2} sx={{ marginTop: 2 }}>
              <Typography variant="h1" sx={{ fontWeight: 'bold' }}>
                Last Access Date
              </Typography>
            </Grid>
            <Grid item display={'flex'} columnGap={2}>
              <BakeasyDatePicker label={'From:'} />
              <BakeasyDatePicker label={'To:'} />
            </Grid>

            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              lg={6}
              xl={6}
              sx={{ marginTop: 2 }}
            >
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                  <BakeasySelectLabel
                    required={true}
                    label={'Stores'}
                    size="small"
                    statusOptions={STORES}
                    fullWidth={true}
                    value={selectStores}
                    onChange={(event) => setSelectStores(event?.target?.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                  <BakeasySelectLabel
                    required={true}
                    label={'Products'}
                    size="small"
                    statusOptions={PRODUCTS}
                    fullWidth={true}
                    value={selectProduct}
                    onChange={(event) => setSelectProduct(event?.target?.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                  <BakeasySelectLabel
                    required={true}
                    label={'Status'}
                    size="small"
                    statusOptions={STATUS}
                    fullWidth={true}
                    value={selectStatus}
                    onChange={(event) => setSelectStatus(event?.target?.value)}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        );
      case 'deActivate':
        return (
          <Grid px={1} sx={{ width: '80%' }}>
            <BakeasyTextField
              //label={t('TYPE_DEACTIVATE_HERE')}
              placeHolder={t('TYPE_DEACTIVATE_HERE')}
              type={''}
              fullWidth={true}
              name={''}
              value={text}
              maxLength={10}
              onChange={function (
                event: React.ChangeEvent<HTMLInputElement>
              ): void {
                setText(event?.target.value);
              }}
            />
          </Grid>
        );
      case 'reActivate':
        return (
          <Grid px={1} sx={{ width: '80%' }}>
            <BakeasyTextField
              //label={t('TYPE_REACTIVATE_HERE')}
              placeHolder={t('TYPE_REACTIVATE_HERE')}
              type={''}
              fullWidth={true}
              name={''}
              value={text}
              maxLength={10}
              onChange={function (
                event: React.ChangeEvent<HTMLInputElement>
              ): void {
                setText(event?.target.value);
              }}
            />
          </Grid>
        );
      case 'store-filter':
        return (
          <>
            {commonFilter()}
            {storeFilter()}
          </>
        );
      case 'store-product-filter':
        return <>{storeProductFilter()}</>;
      case 'product-filter':
        return <>{productFilter()}</>;
      case 'order-filter':
        return <>{orderFilter()}</>;
      case 'activeOrder-filter':
        return <>{activeOrderFilter()}</>;
      case 'message-filter':
        return <>{messageFilter()}</>;
      case 'message-compose':
        return <>{messageCompose()}</>;
      case 'invoice/shipping-filter':
        return <>{commonshippingInvoiceFilter()}</>;
      case 'invoice-filter':
        return <>{invoiceFilter()}</>;
      case 'cancel':
        return <>{Cancel()}</>;
      case 'language-Dialog':
        return <>{languageDialog()}</>;
      case 'unassign':
        return (
          <BakeasyTextField
            label={'Type UNASSIGN here'}
            placeHolder={'Type UNASSIGN here'}
            type={''}
            fullWidth={true}
            name={''}
            value={text}
            maxLength={10}
            onChange={function (
              event: React.ChangeEvent<HTMLInputElement>
            ): void {
              setText(event?.target.value);
            }}
          />
        );
      case 'assign':
        return (
          <BakeasyTextField
            label={'Type ASSIGN here'}
            placeHolder={'Type ASSIGN here'}
            type={''}
            fullWidth={true}
            name={''}
            value={text}
            maxLength={10}
            onChange={function (
              event: React.ChangeEvent<HTMLInputElement>
            ): void {
              setText(event?.target.value);
            }}
          />
        );
      case 'productActivation':
        return (
          <Dropdown.Status
            label={t('STATUS')}
            placeholder="Select Status"
            size="small"
            required={true}
            fullWidth={true}
            options={PRODUCT_STATUS_ARRAY}
            value={selectedStatus}
            onChange={(event: any) => {
              setSelectedStatus(event.target.value);
            }}
          />
        );
      default:
        return <></>;
    }
  }

  function languageDialog() {
    return (
      <Grid item>
        <BakeasySelectLabelLanguage
          value={selectedLanguage}
          onChange={(e: any) => {
            setSelectedLanguage(e.target.value);
          }}
        />
      </Grid>
    );
  }

  return (
    <React.Fragment>
      <BootstrapDialog
        open={props?.dialog?.open ? props?.dialog?.open : false}
        fullWidth={true}
        maxWidth={maxWidth}
      >
        <DialogTitle
          sx={{ margin: 0, padding: 2 }}
          style={{ fontWeight: 600 }}
          minWidth={200}
        >
          <Grid container sx={{ flexDirection: 'row', fontSize: '1.2rem' }}>
            {t(props?.dialog?.title as string)}
          </Grid>
        </DialogTitle>

        <IconButton
          onClick={handleOnClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <Close />
        </IconButton>
        <Divider />
        <DialogContent sx={{ margin: 0 }}>
          <Grid>
            {props?.dialog?.message && <Grid>{props?.dialog?.message}</Grid>}
            {props?.dialog?.type &&
              getContent(props?.dialog?.type, props?.dialog?.data)}
            {error && (
              <Grid mt={2} px={1} sx={{ color: 'red' }}>
                {error ?? error}
              </Grid>
            )}
          </Grid>
        </DialogContent>
        {props?.dialog?.type != 'contact' && <Divider />}
        <DialogActions sx={{ marginRight: 1, columnGap: 1 }}>
          {props?.dialog?.onNoClick && (
            <BakeasyButton
              fullWidth={false}
              label={t(getLabelForNoButton(props?.dialog?.type))}
              variant="outlined"
              onClick={handleOnClose}
            />
          )}

          {props?.dialog?.onYesClick && (
            <BakeasyButton
              fullWidth={false}
              label={t(getLabelForYesButton(props?.dialog?.type))}
              onClick={handleOnYes}
            />
          )}
        </DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
}
